import priceDataProxy from '../../../proxies/prices/PriceDataProxy';
import ServiceBase from '../../ServiceBase';

class PriceDataService extends ServiceBase {
  getPriceData(params, source) {
    return this.applyMemoryCache('PriceDataService.getPriceData', params)(() =>
      priceDataProxy.getPriceData(params, source),
    );
  }

  getLatestPrice(params) {
    return this.processSubscription(data => {
      var res = [];

      res.push(this.getSubscribtionChannel(params.Code));

      return res;
    })(() =>
      this.applyMemoryCache('PriceDataService.GetLatestPrice', params)(() =>
        priceDataProxy.getLatestPrice(params),
      ),
    );
  }

  downloadPriceData(params) {
    return this.applyMemoryCache('PriceDataService.DownloadPriceData', params)(
      () => priceDataProxy.downloadPriceData(params),
    );
  }
}

const priceDataService = new PriceDataService();
export default priceDataService;
